import React from 'react';
import { Select, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const LanguageSelector = ({ style = {}, compact = false }) => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'ur', name: 'اردو', flag: '🇵🇰' },
    { code: 'sl', name: 'Slovenščina', flag: '🇸🇮' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'sq', name: 'Shqip', flag: '🇦🇱' }
  ];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    // Update HTML direction for RTL languages
    const isRtl = langCode === 'ar' || langCode === 'ur';
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    document.documentElement.lang = langCode;
  };

  return (
    <Space style={style}>
      {!compact && <GlobalOutlined />}
      <Select
        value={i18n.language}
        style={{ width: compact ? 120 : 150 }}
        onChange={handleLanguageChange}
        size="small"
      >
        {languages.map(lang => (
          <Option key={lang.code} value={lang.code}>
            <Space>
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </Space>
          </Option>
        ))}
      </Select>
    </Space>
  );
};

export default LanguageSelector;